import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import permissionService from "../Services/permissionService";
import managePermissionService from "../Services/managePermissionService";
import toast from "react-hot-toast";
import Head from "../Components/Head";

const ManagePermission = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let role = parseInt(params.get("id"));

  useEffect(() => {
    const getPermissions = async () => {
      try {
        const response = await managePermissionService.fetchByRole(role);
        setPermissions(response.permissions);
      } catch (error) {
        console.log(error);
      }
    };
    getPermissions();
  }, []);

  useEffect(() => {
    if (permissions.length > 0) {
      let array = [];
      for (const permission of permissions) {
        let active = false;
        if (
          permission.create ||
          permission.read ||
          permission.update ||
          permission.delete ||
          permission.status
        ) {
          active = true;
        }
        array.push({
          permission: permission.id,
          role: role,
          create: permission.create,
          read: permission.read,
          update: permission.update,
          delete: permission.delete,
          status: permission.status,
          active: active,
          name: permission.name,
        });
      }
      setData(array);
    }
  }, [permissions]);

  const submit = () => {
    let array = [];
    for (const object of data) {
      if (object.active) {
        if (
          object.create ||
          object.read ||
          object.update ||
          object.delete ||
          object.status
        ) {
          array.push(object);
        }
      }
    }
    managePermissionService.change(role, { permissions: array }).then((res) => {
      toast.success("Permissions Updated successfully");
    });
  };

  const handleChange = (
    add = false,
    remove = false,
    name,
    value,
    permission,
    index
  ) => {
    if (add) {
      let item = {
        permission: permission.permission,
        role: role,
        create: 0,
        read: 1,
        update: 0,
        delete: 0,
        status: 0,
        active: true,
      };
      setData((d) => {
        const arr = [...d];
        arr[index] = { ...arr[index], ...item };
        return arr;
      });
    } else if (remove) {
      let item = {
        permission: permission.permission,
        role: role,
        create: 0,
        read: 0,
        update: 0,
        delete: 0,
        status: 0,
        active: false,
      };
      setData((d) => {
        const arr = [...d];
        arr[index] = { ...arr[index], ...item };
        return arr;
      });
    } else {
      let item = { ...data[index], [name]: value ? 1 : 0 };
      setData((d) => {
        const arr = [...d];
        arr[index] = { ...arr[index], ...item };
        return arr;
      });
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Head
            heading="Permission Details"
            button_text="Add"
            navigation={() => submit()}
          />
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-center w-full text-black text-[10px]">
                  <th className="py-4 w-[1%]">Permission</th>
                  <th className="py-4 w-[5%] text-left">Name</th>
                  <th className="py-4 w-[2%]">Create</th>
                  <th className="py-4 w-[2%]">Read</th>
                  <th className="py-4 w-[2%]">Update</th>
                  <th className="py-4 w-[2%]">Delete</th>
                  <th className="py-4 w-[4%]">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.map((value, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-center"
                  >
                    <td className="py-4 w-[1%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="permission"
                        checked={value.active}
                        onChange={(e) =>
                          handleChange(
                            !value.active,
                            value.active,
                            e.target.name,
                            false,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                    <td className="py-4 w-[5%] font-bold text-left text-gray-600">
                      {value.name}
                    </td>

                    <td className="py-4 w-[3%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="create"
                        checked={data[index]?.create ? true : false}
                        onChange={(e) =>
                          handleChange(
                            false,
                            false,
                            e.target.name,
                            data[index].create ? false : true,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                    <td className="py-4 w-[3%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="read"
                        checked={data[index]?.read ? true : false}
                        onChange={(e) =>
                          handleChange(
                            false,
                            false,
                            e.target.name,
                            data[index].read ? false : true,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                    <td className="py-4 w-[3%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="update"
                        checked={data[index]?.update ? true : false}
                        onChange={(e) =>
                          handleChange(
                            false,
                            false,
                            e.target.name,
                            data[index].update ? false : true,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                    <td className="py-4 w-[3%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="delete"
                        checked={data[index]?.delete ? true : false}
                        onChange={(e) =>
                          handleChange(
                            false,
                            false,
                            e.target.name,
                            data[index].delete ? false : true,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                    <td className="py-4 w-[4%]">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="status"
                        checked={data[index]?.status ? true : false}
                        onChange={(e) =>
                          handleChange(
                            false,
                            false,
                            e.target.name,
                            data[index].status ? false : true,
                            value,
                            index
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </main>
  );
};

export default ManagePermission;
